import { Component, AfterViewInit, ViewContainerRef, NgZone, ChangeDetectorRef, } from '@angular/core';
import { Router, ActivatedRoute, } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';

import {
  TdLoadingService, TdMediaService, TdDialogService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
} from '@covalent/core';

import { Farmaco } from '../../../models/';
import { FarmacosService, LoginService } from '../../../services/';
import { FarmacosDetalleComponent } from './detallefarmacos/detallefarmacos.component';

@Component({
  selector: 'qs-farmacos',
  templateUrl: './farmacos.component.html',
  styleUrls: ['./farmacos.component.scss'],
  viewProviders: [FarmacosService],
})
export class FarmacosComponent implements AfterViewInit {

  private idPaciente: string;
  private farmacos: any;

  private isSmallScreen: boolean = false;
  private _querySubscription: Subscription;

  private columnsAll: ITdDataTableColumn[] = [
    { name: 'FECHA_INICIO_TRATAMIENTO', label: 'Fecha Inicio', tooltip: 'Fecha Inicio tratamiento', sortable: false },
    { name: 'FECHA_FIN_TRATAMIENTO', label: 'Fecha Fin', tooltip: 'Fecha fin de tratamiento', sortable: false },
    { name: 'NOM', label: 'Nombre', tooltip: 'Nombre', sortable: true },
    { name: 'DURACION_TRATAMIENTO', label: 'Duración Tratamiento', tooltip: 'Duración Tratamiento', sortable: true },
    { name: 'ID_MEDICA', label: 'ID_MEDICA', sortable: true, hidden: true },
    { name: 'TIPO_TRATAMIENTO', label: 'TIPO_TRATAMIENTO', sortable: true, hidden: true },
    { name: 'NUM_EXPEDIENTE', label: 'NUM_EXPEDIENTE', sortable: false, hidden: true },
    { name: 'ULTPLANTTO', label: 'ULTPLANTTO', sortable: false, hidden: true },
    { name: 'NOMCEN', label: 'Duración', sortable: false, hidden: true },
    { name: 'FECHA_PROX_ENTREGA', label: 'FECHA_PROX_ENTREGA', sortable: false, hidden: true },
  ];

  private columns: ITdDataTableColumn[] = this.columnsAll;
  // Datos
  private filteredData: any[] = [];
  private filteredDataTotal: number;

  // Propiedades
  private clickable: boolean = true;
  private selectable: boolean = false;
  private sortable: boolean = true;
  private sortBy: string = 'ID_MEDICA';
  private sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  private searchTerm: string = '';

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _dialogService: TdDialogService,
    private _farmacosService: FarmacosService,
    private _loginService: LoginService,
    private _dataTableService: TdDataTableService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService, ) { }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this._titleService.setTitle('Farmacos');
    this.idPaciente = this._loginService.consulta.numeroExpediente;
    this._loadingService.register('farmacos.load');
    this._farmacosService.obtenerPlanTratamiento(this.idPaciente).subscribe((res: any) => {
      this.farmacos = res.respuesta || '';
      this.filteredData = this.farmacos;
      this.filteredDataTotal = this.farmacos.length || 0;
      this._loadingService.resolve('farmacos.load');
    }, (error: Error) => {
      this._loginService.mostrarMensaje('Error obteniendo fármacos.', 'OK', 6000);
      this._loadingService.resolve('farmacos.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  openDetail(farmaco: any): void {
     let dialogRef: any = this._dialogService.open(FarmacosDetalleComponent, {
       data: farmaco,
       width: '75%',
       role: 'dialog',
     });
     dialogRef.componentInstance.farmaco = farmaco;
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.farmacos;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredDataTotal = newData.length;
    newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    this.filteredData = newData;
  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/farmacos/farmacos.component.ts